module.exports = __webpack_public_path__ + "static/TFP-logo-header-red.6937adeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TFP-logo-header-red.png
// module id = 115
// module chunks = 35783957827783 263791100135453